import React, { useState } from "react";

export default function ToolTip({ title, children }) {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            style={{ position: 'relative' }}>
            {children}
            {showTooltip && (
                <div style={{
                    position: "absolute",
                    backgroundColor: "black",
                    maxWidth: "200px",
                    marginTop: "5px",
                    color: "white",
                    padding: '5px',
                    borderRadius: '5px',
                    fontSize:"12px"
                }}>{title}</div>
            )}
        </div>
    );
}